import { Dispatch, useCallback } from 'react';
import { LinkTrackingData } from '../../../../../../AnalyticsContext/LinkTracking';
import { safeMemo } from '../../../../../../util/safeMemo';
import { SuggestionData } from '../../../types';
import { FilterSuggestion } from '../FilterSuggestion/FilterSuggestion';
import { PracticeSuggestion } from '../PracticeSuggestion/PracticeSuggestion';
import { PractitionerSuggestion } from '../PractitionerSuggestion/PractitionerSuggestion';
import { SearchSuggestion } from '../SearchSuggestion/SearchSuggestion';
import { Clickable, Item } from './SuggestionListItem.styles';

interface Props {
  suggestion: SuggestionData;
  onChoose: (suggestion: SuggestionData, index: number) => void;
  onMouseOver: Dispatch<number>;
  index: number;
  trackingData: LinkTrackingData;
}

export const SuggestionListItem = safeMemo(
  ({ suggestion, onChoose: onClick, onMouseOver, index, trackingData }: Props) => {
    const handleClick = useCallback(() => onClick(suggestion, index), [index, onClick, suggestion]);
    const handleMouseOver = useCallback(() => onMouseOver(index), [index, onMouseOver]);

    return (
      <Clickable
        onClick={handleClick}
        onMouseOver={handleMouseOver}
        tabIndex={0}
        onFocus={handleMouseOver}
      >
        <Item>
          {suggestion.type === 'FilterSuggestion' && (
            <FilterSuggestion filters={suggestion.filters} trackingData={trackingData} />
          )}

          {suggestion.type === 'TextSuggestion' && (
            <SearchSuggestion term={suggestion.filters.text} trackingData={trackingData} />
          )}

          {suggestion.type === 'PracticeSuggestion' && (
            <PracticeSuggestion
              specialties={suggestion.practice.specialties}
              name={suggestion.practice.name}
              suburb={suggestion.practice.suburb}
              state={suggestion.practice.state}
              trackingData={trackingData}
            />
          )}

          {suggestion.type === 'PractitionerSuggestion' && (
            <PractitionerSuggestion
              specialties={suggestion.practitioner.specialties}
              title={suggestion.practitioner?.title}
              firstName={suggestion.practitioner?.firstName}
              lastName={suggestion.practitioner?.lastName}
              suburb={suggestion.practitioner?.suburb}
              state={suggestion.practitioner?.state}
              imagePath={suggestion.practitioner.imagePath}
              trackingData={trackingData}
            />
          )}
        </Item>
      </Clickable>
    );
  },
);
